import React from 'react';
import {
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import SingleTick from '../../../../../../assets/customSVG/inbox/webchat/SingleTick';
import DoubleTick from '../../../../../../assets/customSVG/inbox/webchat/DoubleTick';
import { messageStatus } from '../../../../constants/WebchatConstants';
import moment from 'moment';
import { Tooltip } from 'antd';
import './loadingCss.css';

const MessageStatus = ({ status = '', timestamp, participantType }) => {
  const msgStatus = messageStatus[status];
  return (
    <RenderStatus
      status={msgStatus}
      timestamp={timestamp}
      visible={participantType !== 'END_USER'}
    />
  );
};

export default MessageStatus;

const RenderStatus = ({ status, timestamp, visible }) => {
  if (!visible) return null;

  switch (status) {
    case 'new':
      // check if the the time is less than 1 minutes in utc if is then show the clock else show the exclamation
      const timeDiff = moment().utc().diff(moment(timestamp).utc(), 'minutes');
      if (timeDiff < 1) {
        return <div className="spinStatusLoader"></div>
      }
      return (
        <div className="flex items-center gap-2">
          <Tooltip title="Message Might Not Be Delivered">
            <ExclamationCircleOutlined
              style={{ color: '#ff4d4f', fontSize: '12px', cursor: 'pointer' }}
            />
          </Tooltip>
        </div>
      );
    case 'sent':
      return (
        <div className="flex items-center gap-2">
          <SingleTick />
        </div>
      );
    case 'delivered':
      return (
        <div className="flex items-center gap-2">
          <DoubleTick />
        </div>
      );
    case 'read':
      return (
        <div className="flex items-center gap-2">
          <DoubleTick color="green" />
        </div>
      );
    default:
      return null;
  }
};


